var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeakAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    className: "p-fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5776 5.94659L15.5835 5.95274L15.5987 5.96865L15.6555 6.0288C15.7048 6.08119 15.7764 6.15778 15.8672 6.25615C16.0487 6.45283 16.3069 6.73682 16.6163 7.08862C17.2344 7.79137 18.0603 8.76888 18.8882 9.8645C19.7139 10.9572 20.5538 12.1836 21.1908 13.3828C21.8154 14.5586 22.3 15.808 22.3 16.9194C22.3 20.9863 19.0409 24.3 15 24.3C10.959 24.3 7.69995 20.9863 7.69995 16.9194C7.69995 15.808 8.18446 14.5586 8.80907 13.3828C9.44606 12.1836 10.286 10.9572 11.1117 9.8645C11.9396 8.76888 12.7655 7.79137 13.3836 7.08862C13.693 6.73682 13.9512 6.45283 14.1327 6.25615C14.2235 6.15778 14.2951 6.08119 14.3444 6.0288L14.4012 5.96865L14.4164 5.95274L14.4223 5.94659C14.5732 5.78908 14.7818 5.70001 15 5.70001C15.2181 5.70001 15.4267 5.78908 15.5776 5.94659ZM14.5851 8.14528C14.7375 7.97199 14.8769 7.81589 15 7.67951C15.123 7.81589 15.2624 7.97199 15.4149 8.14528C16.0155 8.82829 16.8146 9.77417 17.6117 10.8291C18.411 11.8869 19.1961 13.0382 19.7778 14.1334C20.372 15.2519 20.7 16.2135 20.7 16.9194C20.7 20.1213 18.1387 22.7 15 22.7C11.8612 22.7 9.29995 20.1213 9.29995 16.9194C9.29995 16.2135 9.62794 15.2519 10.2221 14.1334C10.8038 13.0382 11.5889 11.8869 12.3882 10.8291C13.1853 9.77417 13.9844 8.82829 14.5851 8.14528Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p-fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.95C0 2.21619 2.21619 0 4.95 0H25.05C27.7838 0 30 2.21619 30 4.95V25.05C30 27.7838 27.7838 30 25.05 30H4.95C2.21619 30 0 27.7838 0 25.05V4.95ZM4.95 1.6H25.05C26.9002 1.6 28.4 3.09985 28.4 4.95V25.05C28.4 26.9002 26.9002 28.4 25.05 28.4H4.95C3.09985 28.4 1.6 26.9002 1.6 25.05V4.95C1.6 3.09985 3.09985 1.6 4.95 1.6Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeakAlert);
export default __webpack_public_path__ + "static/media/LeakAlert.a981161eb57477379e27d25dfba138ac.svg";
export { ForwardRef as ReactComponent };